export default __webpack_public_path__ + "static/media/migrationt.db63f591.png";